import { Flex, Form, Input, Radio, Select, Typography } from "antd"

import { FixedPriceFields } from "@src/pages/checkoutUpsert/ui/FixedPriceFields"
import { ImageUploaderUI } from "@src/shared/componemts/ImageUploadUI"
import { ImageUpload } from "@src/shared/componemts/ImageUploadUI/entity/ImageUpload"
import css from "./index.module.css"

type CheckoutUpsertRightProps = {
  disabled: boolean
  image: ImageUpload
  isNew: boolean
}
const CheckoutUpsertRight = ({
  disabled,
  image,
  isNew,
}: CheckoutUpsertRightProps) => {
  const p = Form.useWatch("pricing_type", Form.useFormInstance())
  return (
    <div className={css.checkoutUpsertRight}>
      <Flex vertical>
        <Typography.Text strong={true}>Checkout image</Typography.Text>
        <Form.Item
          id="GENERATED_ID_CHECKOUTUPSERTRIGHT_FORM_ITEM_VOID_1"
          name="image"
          style={{ margin: 0 }}
        >
          <ImageUploaderUI
            accept=".jpg,.jpeg"
            control={image}
            disabled={disabled}
          />
        </Form.Item>
      </Flex>

      <Flex gap={16} vertical>
        <Flex align="center" gap={16}>
          <Typography.Text strong={true}>Pricing type</Typography.Text>
          <Form.Item
            id="GENERATED_ID_CHECKOUTUPSERTRIGHT_FORM_ITEM_VOID_2"
            name="pricing_type"
            style={{ margin: 0 }}
          >
            <Radio.Group buttonStyle="solid" disabled={!isNew} size="small">
              <Radio.Button type="primary" value="fixed_price">
                Fixed Price
              </Radio.Button>
              <Radio.Button value="no_price">Let Your User Choose</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Flex>

        {p === "fixed_price" && <FixedPriceFields />}
      </Flex>
    </div>
  )
}

export default CheckoutUpsertRight
